import {observer} from "mobx-react-lite";
import {FormControl, IconButton, Input, InputAdornment, InputLabel} from "@mui/material";
import {Clear} from "@mui/icons-material";
import React, {useEffect, useMemo} from "react";
import {useStores} from "~/stores";
import {debounceTime, Subject} from "rxjs";

const SEARCH_DEBOUNCE_MS = 500;

export const SpendConcentrationSearchComponent = observer(() => {
    const {spendConcentrationStore} = useStores();
    const filterController = spendConcentrationStore.sCPageController.filterController;

    const [inputValue, setInputValue] = React.useState(filterController.supplierSearchValue);
    const pipe = useMemo(() => new Subject<string>(), []);

    useEffect(() => {
        const sub = pipe.pipe(
            debounceTime(SEARCH_DEBOUNCE_MS),
        ).subscribe(search => {
            filterController.setSupplierSearch(search);
        });
        return () => sub.unsubscribe();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pipe]);

    useEffect(() => {
        // Keep the input in sync when the filter changes from elsewhere (e.g. breadcrumbs, category selection)
        setInputValue(filterController.supplierSearchValue);
    }, [filterController.supplierSearchValue]);

    const handleChange = (value: string) => {
        setInputValue(value);
        pipe.next(value);
    };

    const handleClear = () => {
        // Clearing should be immediate, not wait out the debounce
        setInputValue('');
        pipe.next('');
        filterController.setSupplierSearch('');
    };

    return <FormControl variant="standard" fullWidth={true} className="search-field">
        <InputLabel htmlFor="supplier-search-field">
            Vendor search
        </InputLabel>
        <Input
            id="supplier-search-field"
            type="text"
            fullWidth={true}
            endAdornment={
                <InputAdornment position="end">
                    <IconButton
                        aria-label="clear search"
                        onClick={handleClear}
                    >
                        <Clear/>
                    </IconButton>
                </InputAdornment>
            }
            value={inputValue}
            onChange={e => handleChange(e.target.value)}
        />
    </FormControl>
})
